import { PixTransactionResult } from '../types/TransactionResult'
import Money from '../types/Money'
import api from './api'

export const payPix = async (
    paymentPageId: string,
    pixData: object,
    extraFieldsData: Record<string, string>,
    money?: Money,
): Promise<PixTransactionResult> => {
    return await api('/api/payment-page/pay/pix', {
        paymentPageId: paymentPageId,
        pix: pixData,
        ...money ? {
            money: {
                amount: parseFloat(money.amount) * 100,
                currency: money.currency,
            }
        } : {},
        extraFields: extraFieldsData,
    }) as PixTransactionResult
}
